import React from 'react';
import './Delivery.css';

const STEPS = [
  {
    n: '1',
    title: <>We sit down with you, once</>,
    body: 'We walk you through what our AI system will check every day, which signals we will monitor, and what analytics we can deliver.',
  },
  {
    n: '2',
    title: <>We <span>customize it to your project</span></>,
    body: 'You give input. If there is anything you have been burned by before that we are not already checking, we add it.',
  },
  {
    n: '3',
    title: <>Then it runs</>,
    body: 'Our team and our AI system provide the continuous oversight, and the report lands in your inbox on your cadence. We can tailor that too.',
    green: true,
  },
];

const QUOTES = [
  'Where have you been burned before?',
  'What else should we be checking on this project?',
  'Which analytics would change how you make decisions?',
];

function Delivery() {
  return (
    <section className="aqp-section aqp-dl" data-screen-label="How it is delivered">
      <div className="aqp-dl__inner">
        <div className="aqp-reveal aqp-dl__head">
          <span className="aqp-eyebrow">How the program is delivered</span>
          <h2 className="aqp-dl__h2">We sit down with you <span>once.</span> Then it runs.</h2>
        </div>

        <div className="aqp-cols aqp-dl__cols">
          <ol className="aqp-dl__steps">
            {STEPS.map((s, i) => (
              <li key={s.n} className={'aqp-reveal aqp-dl__step' + (s.green ? ' aqp-dl__step--green' : '')}>
                {i < STEPS.length - 1 && <span className="aqp-dl__connector" />}
                <span className="aqp-dl__num"><span>{s.n}</span></span>
                <div>
                  <div className="aqp-dl__step-title">{s.title}</div>
                  <div className="aqp-dl__step-body">{s.body}</div>
                </div>
              </li>
            ))}
          </ol>

          <aside className="aqp-reveal aqp-dl__aside">
            <div className="aqp-dl__aside-eyebrow">The setup meeting</div>
            <div className="aqp-dl__aside-title">This is where you shape the program.</div>
            <div className="aqp-dl__quotes">
              {QUOTES.map((q) => (
                <div key={q} className="aqp-dl__quote">
                  <span className="aqp-dl__quote-mark">&ldquo;</span>
                  <span>{q}</span>
                </div>
              ))}
            </div>
            <div className="aqp-dl__aside-foot">
              Your entire involvement is <strong>one meeting and your own input</strong>. We do the setup,
              we run the program, and we send you what you want.
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}

export default Delivery;
